export function userReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_USERS":
            return payload;
        
        default:
            return state;
    }
}